import { useStaticQuery, graphql } from 'gatsby'
import makeSlugForContentfulPost from "../../lib/makeSlugForContentfulPost";
import { EVENTS, NEWS } from "../../lib/collectionNames";

export const useNews = () => {
  const data = useStaticQuery(graphql`
    query {
      allData: allResource(
        filter: { collection: { eq: "news" } }
        sort: { order: DESC, fields: publishedDate }
      ) {
        nodes {
          id
          slug
          publishedDate(formatString: "MMMM D YYYY")
          data {
            title
            thumbnail
            abstract
          }
        }
      }
      allContentfulNews: allContentfulNews(
        sort: { order: DESC, fields: publishedDate },
        filter: { title: { ne: "Dummy" } }
      ) {
          nodes {
            id
            slug
            publishedDate(formatString: "MMMM D YYYY")
            heading
            subHeading
            thumbnailImage {
              url
            }
            thumbnail{
              file{
                url
              }
            }
          }
      }
    }
  `)

  const { allData: localJSONData, allContentfulNews: allContentfulData } = data;

  const localJSONCards = localJSONData.nodes.map(resource => ({
    id: resource.id,
    slug: `${resource.slug}/`,
    thumbnail: resource.data.thumbnail,
    publishedDate: resource.publishedDate,
    title: resource.data.title,
    abstract: resource.data.abstract,
  }))

  const contentfulCards = allContentfulData.nodes.map(resource => {
    const slug = makeSlugForContentfulPost(resource, NEWS);

    return ({
      id: resource.id,
      slug: `${slug}/`,
      thumbnail: resource.thumbnailImage ? resource.thumbnailImage[0].url : "https:" + resource.thumbnail.file.url,
      publishedDate: resource.publishedDate,
      title: resource.heading,
      abstract: resource.subHeading,
    });
  })

  const allCards = [...contentfulCards, ...localJSONCards];

  return allCards
}

export default useNews
